import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './RegistrationSuccess.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const RegistrationSuccess = () => {
    const { eventNameId } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/public/events/${eventNameId}`);
                setEvent(response.data);
            } catch (err) {
                setError('Event not found');
            } finally {
                setLoading(false);
            }
        };

        if (eventNameId) {
            fetchEvent();
        }
    }, [eventNameId]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (error || !event) {
        return <div className="error">Event not found</div>;
    }

    return (
        <div className="registration-success">
            {/* Event Banner with Logo */}
            <div className="event-banner">
                {event.EventImage && (
                    <img src={event.EventImage} alt="Event Logo" className="event-logo" />
                )}
            </div>

            {/* Event Title */}
            <div className="event-header">
                <h1 className="event-title">{event.Name}</h1>
            </div>

            {/* Event Details */}
            <div className="event-details">
                <div className="detail-item location-item">
                    <span className="detail-text">
                        <i className="fas fa-map-marker-alt detail-icon"></i>
                        {event.Location}
                        {event.Address1 && ` - ${event.Address1}`}
                        {event.City && `, ${event.City}`}
                        {event.StateProvince && `, ${event.StateProvince}`}
                        {event.Country && `, ${event.Country}`}
                    </span>
                </div>

                <div className="detail-item date-time-row">
                    <div className="date-section">
                        <i className="fas fa-calendar-alt detail-icon"></i>
                        <span className="detail-text">
                            {formatDate(event.StartDate)} - {formatDate(event.EndDate)}
                        </span>

                        <i className="fas fa-clock detail-icon"></i>
                        <span className="detail-text">
                            {formatTime(event.StartDate)} - {formatTime(event.EndDate)} {event.TimeZone || 'EDT'}
                        </span>
                    </div>

                </div>
            </div>

            {/* Separator */}
            <div className="separator"></div>

            <div className="success-message">
                <p>Thank you for registering for <i>{event.Name}</i>, we are reviewing your information.</p>
                <p>You will receive an email as soon as your registration is approved.</p>
            </div>
        </div>
    );
};

export default RegistrationSuccess;
